module.exports = __webpack_public_path__ + "img/nutrition-600x450.4f71390a.jpg";